import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import SubfoldersIcon from '@wix/da-ds/pkg/Icons/24x24/Subfolders';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import UnwatchIcon from '@wix/da-ds/pkg/Icons/Unwatch';
import FolderCoverInfo from '../../../FolderCoverInfo';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import GallectionCoverDumbo from '../../../GallectionCoverDumbo';
import folderCardStyles from '../../FolderCard.scss';
const FolderCardContent = ({ className , folder , folder: { subfolders , hasSubfolders: hasSubfoldersFromFolder = !!(subfolders === null || subfolders === void 0 ? void 0 : subfolders.length) , type  } , totalDeviationCount , hasSubfolders: hasSubfoldersOverride , isCurrentUserOwner , width , height  })=>{
    const { t  } = useTranslation();
    const emptyGallectionInfo = {
        gallery: 'folderCard.empty.gallery.info',
        collection: 'folderCard.empty.collection.info'
    };
    const hasSubfolders = hasSubfoldersOverride !== null && hasSubfoldersOverride !== void 0 ? hasSubfoldersOverride : hasSubfoldersFromFolder;
    if (!width || !height) {
        return null;
    }
    if (totalDeviationCount === 0 && isCurrentUserOwner) {
        return /*#__PURE__*/ React.createElement("div", {
            className: folderCardStyles['empty-folder'],
            style: {
                width,
                height
            }
        }, /*#__PURE__*/ React.createElement(UnwatchIcon, {
            className: folderCardStyles['empty-icon'],
            size: IconSize.HUGE
        }), /*#__PURE__*/ React.createElement("div", {
            className: folderCardStyles['empty-folder-info']
        }, t(emptyGallectionInfo[type])));
    }
    const isPremiumFolder = normalizePremiumFolderData(folder.premiumFolderData).isPremium;
    const isFolderThumbPublished = folder.thumb && folder.thumb.isPublished;
    const showBlurredThumbInfoToOwner = isCurrentUserOwner && isPremiumFolder && isFolderThumbPublished;
    return /*#__PURE__*/ React.createElement("div", {
        className: className
    }, hasSubfolders && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: folderCardStyles['subfolders-icon-underlay']
    }), /*#__PURE__*/ React.createElement("div", {
        className: folderCardStyles['top-right-icons']
    }, hasSubfolders && /*#__PURE__*/ React.createElement(SubfoldersIcon, {
        className: classnames(folderCardStyles['subfolders-icon'])
    }))), /*#__PURE__*/ React.createElement(GallectionCoverDumbo, {
        width: width,
        height: height,
        gallection: folder
    }), showBlurredThumbInfoToOwner && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: folderCardStyles['info-icon-underlay']
    }), /*#__PURE__*/ React.createElement("div", {
        className: folderCardStyles['top-right-icons']
    }, /*#__PURE__*/ React.createElement(FolderCoverInfo, null))));
};
export default FolderCardContent;
